import React, { FunctionComponent } from 'react';
import {ClassBuilder} from 'b302-frontend-library';

interface Props {
    children: any;
    className?: string;
    indicatorText?: string;
    bold?: boolean;
}

const HanText: FunctionComponent<Props> = ({ children, className, indicatorText, bold }) => {

    const getClassName = () => {
        return ClassBuilder.createClass('han-text')
            .addIf('han-text__text--bold', bold)
            .addIf(className, className)
            .build();
    };

    return (
        <div className={getClassName()}>
            <span className={'han-text__text'}>
                { children }
            </span>

            { indicatorText &&
                <span className={'han-text__indicator'}>
                    { indicatorText }
                </span>
            }
        </div>
    );
};

export default HanText;
